import { ArrowRightOutlined } from '@ant-design/icons';
import { VoceGuidaCompilazioneDTOTesto } from '@framework/api-client';
import {
  CardFooterButtons,
  CompilationContainer,
  ISubmissionNavigator,
  SUBMISSION_TITLE_FOCUS_ID,
  SubmissionCancelButton,
  SubmissionMenuKey,
  useSubmission,
} from '@framework/frontoffice-submission';
import { useTranslation } from '@framework/i18n';
import { FlexRow, useIdFromUrl } from '@framework/ui';
import { Button, Space } from 'antd';
import { useMemo } from 'react';
import { RouteComponentProps } from 'react-router';
import { NetworkAlertPage } from '../../../../routes/errors/network-alert/NetworkAlertPage';
import { GuideTextStyled } from './GuideTextStyled';

interface Params {
  id: string;
}

export interface ICompilationGuideCardProps
  extends RouteComponentProps<Params> {
  handleNavigation: ISubmissionNavigator;
}

export function CompilationGuideCard(props: ICompilationGuideCardProps) {
  const { handleNavigation } = props;
  const [submissionId] = useIdFromUrl(props, 'id');
  const { t } = useTranslation();

  const { inquiry } = useSubmission(submissionId);

  const guideText = useMemo(() => {
    return inquiry?.vociGuida ?? [];
  }, [inquiry?.vociGuida]);

  if (!inquiry) {
    return (
      <NetworkAlertPage
        noLayout
        message={t(
          'compilation-guide.impossibile-caricare-la-guida-alla-compilazione',
          'Impossibile caricare la guida alla compilazione della domanda',
        )}
        error={t(
          'compilation-guide.domanda-non-trovata-in-archivio',
          `Domanda non trovata in archivio: id {{submissionId}}`,
          { submissionId: submissionId ?? '' },
        )}
      />
    );
  }

  return (
    <>
      <h1 className="sr-only" id={SUBMISSION_TITLE_FOCUS_ID} tabIndex={-1}>
        {t('menu-items.guida-alla-compilazione', 'Guida alla compilazione')}
      </h1>
      <CompilationContainer>
        {guideText?.map((voceGuida, index) => (
          <GuideTextStyled
            key={voceGuida.id ?? `guide-text-${index}`}
            text={voceGuida.testo as VoceGuidaCompilazioneDTOTesto[]}
          />
        ))}
      </CompilationContainer>
      <CardFooterButtons>
        <FlexRow
          right={
            <Space>
              <SubmissionCancelButton />
              <Button
                size="large"
                type="primary"
                onClick={() => {
                  handleNavigation.navigate(SubmissionMenuKey.Guide, 'next');
                }}
              >
                {t('compilation-guide.avvia', 'Avvia')}{' '}
                <ArrowRightOutlined aria-hidden />
              </Button>
            </Space>
          }
        ></FlexRow>
      </CardFooterButtons>
    </>
  );
}
